import { Checkbox } from "@material-ui/core";
import * as React from "react";
import { useEffect, useState } from "react";
import UniversalTable from "../UniversalTable/UniversalTable";
import { IUniversalTableColumn } from "../UniversalTable/interfaces";
import {
    addEmptyOrderFile,
    getAllEmptyOrderFiles,
    getUserSpecificEmptyOrderFiles,
    removeEmptyOrderFile
} from "../../../stores/emptyOrderFiles/EmptyOrderFilesAction";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import ToastStatusEnum from "../../../constants/ToastStatusEnum";


export interface EmptyOrderFilesProps {
    orderId?: number;
    onChange?: any;
    onPostChange?: any;
}

function createRequest(orderId: number, path) {
    return {orderId: Number(orderId), s3FilePath: path};
}

const EmptyOrderFilesPure: React.FunctionComponent<EmptyOrderFilesProps> = ({
                                                                                orderId,
                                                                                onChange,
                                                                                onPostChange
                                                                            }: EmptyOrderFilesProps) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAllEmptyOrderFiles());
        if (orderId) {
            dispatch(getUserSpecificEmptyOrderFiles(orderId));
        }
    }, [dispatch, orderId]);

    const emptyOrderFiles = useSelector(state => state.emptyOrder?.files ? Object.values(state.emptyOrder?.files) : []);
    const usersEmptyOrderFiles = useSelector(state => state.emptyOrder?.userFiles);

    const [selectedFiles, setSelectedFiles] = useState([]);

    const {enqueueSnackbar} = useSnackbar();

    useEffect(() => {
        if (usersEmptyOrderFiles && orderId) {
            setSelectedFiles(Object.values(usersEmptyOrderFiles));
        }
    }, [orderId, usersEmptyOrderFiles]);

    function isChecked(path) {
        return selectedFiles.includes(path);
    }

    const handleEmptyOrderSelection = path => {
        let newUserFiles = [...selectedFiles, path];
        let added = true;
        if (isChecked(path)) {
            newUserFiles = selectedFiles.filter(p => p !== path);
            added = false;
        }

        if (onChange) {
            onChange(newUserFiles);
        }
        else {
            const request = createRequest(orderId, path);
            dispatch(added ? addEmptyOrderFile(request) : removeEmptyOrderFile(request)).then(() => {
                enqueueSnackbar("File was " + (added ? "added" : "removed") + " and the selection saved.", {variant: ToastStatusEnum.Info});
                onPostChange(path);
            });
        }
        setSelectedFiles(newUserFiles);
    };

    const emptyOrderColumns: IUniversalTableColumn[] = [
        {
            type: "dateTime",
            title: "Creation",
            field: "created",
            defaultSort: "desc"
        },
        {
            type: "component",
            title: "Path",
            field: "",
            component: rowData => rowData["path"].replace(rowData["name"], "").replace("empty_orders_files/", "").slice(0, -1)
        },
        {
            type: "text",
            title: "Filename",
            field: "name"
        },
        {
            type: "size",
            title: "Size",
            field: "size"
        },
        {
            type: "component",
            title: "Selected",
            field: "path",
            component: fieldValue => <Checkbox checked={isChecked(fieldValue)}
                                               onClick={() => handleEmptyOrderSelection(fieldValue)} />
        },
    ];

    return <UniversalTable columns={emptyOrderColumns} data={emptyOrderFiles} isLoading={emptyOrderColumns.length === 0}
                           searchable={true} />;
};


export const EmptyOrderFilesComponent = EmptyOrderFilesPure;